"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pitColumnFullWidthProps = exports.pitColumnProps = exports.pitTypes = void 0;
const constants_1 = require("utils/constants");
exports.pitTypes = {
    SET_DATA_GRID: 'PIT TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'PIT TYPES ON PAGE CHANGE',
    ON_MUTATION_CLICK: 'PIT TYPES ON MUTATION',
    ON_CHANGE_DATAITEM: 'PIT TYPES ON CHANGE DATAITEM',
    ON_SAVE_DATAITEM: 'PIT TYPES ON SAVE DATAITEM',
    ON_DELETE: 'PIT TYPES ON DELETE',
    ON_FILTER_CHANGE: 'PIT TYPES ON FILTER CHANGE',
    ON_SORT_CHANGE: 'PIT TYPES ON SORT CHANGE',
    SET_ERROR: 'PIT TYPES SET ERROR',
    SET_LOADING: 'PIT TYPES SET LOADING',
    GET_DETAIL: 'PIT TYPES GET DETAIL'
};
exports.pitColumnProps = [
    {
        show: true,
        field: 'pit',
        title: 'PIT',
        width: '400px',
        filter: 'text'
    },
    {
        show: true,
        field: 'contractors',
        title: 'Contractor',
        width: '400px',
        filter: 'text',
        filterable: false,
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '180px',
        filter: 'text'
    },
    {
        show: true,
        field: 'is_active',
        title: 'Status',
        width: '140px',
        filter: 'boolean'
    },
];
exports.pitColumnFullWidthProps = [
    ...exports.pitColumnProps
];
exports.pitColumnFullWidthProps[0] = {
    show: true,
    field: 'pit',
    title: 'PIT',
    width: 'auto',
    filter: 'text'
};
